import React from 'react';
import ImportWizardPage from './ImportWizardPage';
import MapFindingMandatoryFieldsStep from '../components/finding/MapFindingMandatoryFieldsStep';
import MapFindingAdditionalFieldsStep from '../components/finding/MapFindingAdditionalFieldsStep';
import FindingPreviewStep from '../components/finding/PreviewStep';
import FindingSubmitModal from '../components/finding/SubmitModal';
import FindingSuccessModal from '../components/finding/SuccessModal';

const initialTargetDropdownSelections: Record<string, string> = {
  asset_identifier: 'asset_tag',
};

const NewDataFindingsImportPage: React.FC = () => (
  <ImportWizardPage
    title="New Data Findings Import"
    entityLabelPlural="findings"
    listPath="/findings"
    initialTargetDropdownSelections={initialTargetDropdownSelections}
    uniqueFieldKey="asset_identifier"
    MapMandatoryFieldsStep={MapFindingMandatoryFieldsStep}
    MapAdditionalFieldsStep={MapFindingAdditionalFieldsStep}
    PreviewStep={FindingPreviewStep}
    SubmitModal={FindingSubmitModal}
    SuccessModal={FindingSuccessModal}
  />
);

export default React.memo(NewDataFindingsImportPage);
